import { createContext } from 'react';

import { useNewStudiesState } from './hooks/useNewStudiesState.js';
import { GlobalLoadingState, ToolkitControllerGlobal } from './types.js';

export const ToolkitControllerGlobalContext = createContext<ToolkitControllerGlobal | null>(null);

export const StudiesContext = createContext<ReturnType<typeof useNewStudiesState> | null>(null);

export const FTUXContext = createContext<Record<string, never> | null>(null);

export const GlobalLoadingContext = createContext<GlobalLoadingState | null>(null);
